export default "<div class=\"video-container\" id=\"video-container\" #bbvmsContainer></div>\n";